module.exports = __webpack_public_path__ + "static/img/index-pro-移动行销.0163ca58.png";